import { useEffect, useState } from 'react';

import type { ApiListingMiniExtra } from '#/api/types/ApiListingMini';
import { listingApiFetchOrgListings } from '#/modules/listing/orgs/api/listingApiFetchOrgListings';
import { trackError } from '#/utils/trackError';

export function useFetchOrgListings(
  initialListings: ApiListingMiniExtra[],
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT',
  orgId: string,
) {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [prevPage, setPrevPage] = useState(1);
  const [listings, setListings] = useState(initialListings);
  const [prevListingType, setPrevListingType] = useState('JOB');

  useEffect(() => {
    if (loading) {
      return;
    }
    if (listingType !== prevListingType) {
      setPrevListingType(listingType);
      setPage(1);
      setPrevPage(1);
      setListings(initialListings);
    } else if (page > 1 && page !== prevPage) {
      setLoading(true);
      setPrevPage(page);
      listingApiFetchOrgListings(orgId, listingType, page)
        .then((response) => {
          setListings([...listings, ...response]);
          setLoading(false);

          return undefined;
        })
        .catch((err: Error) => {
          setLoading(false);
          trackError(err);
        });
    }
  }, [
    page,
    prevPage,
    listingType,
    prevListingType,
    listings,
    initialListings,
    orgId,
    loading,
  ]);

  return {
    loading,
    listings,
    page,
    setPage,
  };
}
